import {
  Card,
  formatNumber,
  Inline,
  Skeleton,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { useContractorsCosts } from '@omnipresentgroup/domains';
import type { GetContractorsCostsRequest } from '@omnipresentgroup/types';

export const SECTION_TITLE = 'Billing';
export const SECTION_DESC =
  'All Omnipresent fees are handled when you pay your contractor invoices, and are seen as additional line items. There are no other additional or hidden costs for hiring contractors.';
export const PLATFORM_FEE_TITLE = 'Monthly platform fee';
export const PLATFORM_FEE_DESC =
  'This fee is once per contractor, per month, and is added to the first invoice of each calendar month that your contractor creates.';

export const BillingSection = ({
  invoicingCurrency,
  billingCurrency,
}: GetContractorsCostsRequest) => {
  const { data: contractorCosts, isLoading: isLoadingContractorCosts } =
    useContractorsCosts({
      invoicingCurrency,
      billingCurrency,
    });

  return (
    <Stack gap="24">
      <Inline gap="8" align="center">
        <Typography as="h5" size="20" weight="medium" hideParagraphSpacing>
          {SECTION_TITLE}
        </Typography>
      </Inline>
      <Typography as="span" size="14">
        {SECTION_DESC}
      </Typography>
      <Card>
        <Stack py="16" px="24" bg="page" gap="16">
          <Stack gap="4">
            <Inline justify="space-between">
              <Typography as="span" size="14" weight="medium">
                {PLATFORM_FEE_TITLE}
              </Typography>
              {isLoadingContractorCosts ? (
                <Skeleton width={90} height={16} />
              ) : (
                <Typography as="span" size="16" weight="medium">
                  {formatNumber({
                    input: Number(contractorCosts?.totalCost),
                    currency: billingCurrency,
                  })}
                </Typography>
              )}
            </Inline>
            <Typography as="span" size="14" color="subtle">
              {PLATFORM_FEE_DESC}
            </Typography>
          </Stack>
        </Stack>
      </Card>
    </Stack>
  );
};
